import styled from 'styled-components';
import { IToken } from 'store/ducks/globalTypes';

export const TextareaWrapper = styled('div')<IToken>`
  .ant-input {
    min-width: 330px;
    padding: ${(props) => `${props.token.padding}px`};
    border: unset;
    background: ${(props) => props.token.colorFillContent};
    margin-right: ${(props) => `${props.token.marginXXS}px`};
    color: ${(props) => props.token.colorPrimaryText};

    resize: auto;
    overflow: auto;

    max-width: 1200px;
  }

  /* Keep Client Interpretation Baseline fields with original theme color */
  textarea.ant-input {
    background: ${(props) => props.token.colorFillContent};

    &:hover,
    &:focus,
    &:active {
      background: ${(props) => props.token.colorFillContent};
    }
  }
`;
